export const GET_REFERRERS = 'GET_REFERRERS';
export const REFERRERS_FETCH_ERROR = 'REFERRERS_FETCH_ERROR';

export const GET_PARTNERS = 'GET_PARTNERS';
export const PARTNERS_FETCH_ERROR = 'PARTNERS_FETCH_ERROR';
